import { render, staticRenderFns } from "./MembershipVersionCardContent.vue?vue&type=template&id=c898b4ba&"
import script from "./MembershipVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./MembershipVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports